// extracted by mini-css-extract-plugin
export var columnList = "_dx-0";